/**
 *　フォームのバリデーションロジックを提供するサービス
 */
export class FormValidationService {
  /**
   * 必須項目のバリデーション
   * @param value - バリデーションする値
   * @returns バリデーション結果
   */
  public static validateRequired(value: any): boolean {
    if (value === null || value === undefined || value === '') {
      return false;
    }
    return true;
  }

  /**
   * 半角数字のバリデーション
   * @param value - バリデーションする値
   * @returns バリデーション結果
   */
  public static validateHalfWidthNumber(value: any): boolean {
    if (value === null || value === undefined || value === '') {
      return true;
    }
    return /^\d+$/.test(value);
  }

  /**
   * 半角数字と.のバリデーション(小数を含む数値)
   * @param value - バリデーションする値
   * @returns バリデーション結果
   */
  public static validateHalfWidthRealNumber(value: any): boolean {
    if (value === null || value === undefined || value === '') {
      return true;
    }
    // number型に変換して、NaNやInfinityを判定する
    const num = Number(value);

    // 0.や.5のような中途半端な値を判定する
    if (!/^-?\d+(\.\d+)?$/.test(value)) return false;
    return !isNaN(num) && typeof num === 'number' && isFinite(num);
  }

  /**
   * 負の数のバリデーション
   * @param value - バリデーションする値
   * @returns バリデーション結果
   */
  public static validateNegativeNumber(value: any): boolean {
    if (value === null || value === undefined || value === '') {
      return true; // 空は負じゃない
    }

    const num = Number(value);
    return !isNaN(num) && isFinite(num) && num > 0;
  }

  /**
   * メモ機能における入力不可文字のバリデーション
   * @param value - バリデーションする値
   * @returns バリデーション結果
   */
  public static validateMemoInvalidChar(value: any): boolean {
    if (value === null || value === undefined || value === '' || typeof value !== 'string') {
      return true;
    }
    if (Array.from(value).length !== value.length) {
      return false;
    }
    return /^[^©®\u2450-\u24FF\u2160-\u217F\u2776-\u2793]*$/.test(value); //丸文字とローマ数字を弾く
  }

  /**
   * メモ機能における255文字超過のバリデーション
   * @param value - バリデーションする値
   * @returns バリデーション結果
   */
  public static validateMemoTooMatchLength(value: any): boolean {
    if (value === null || value === undefined || value === '' || typeof value !== 'string') {
      return true;
    }
    return value.length < 256;
  }
}
